import React, { useEffect, useMemo, useState } from "react";
import {
  cleaningEffectivness,
  cleaningEffectivnessStatus,
} from "../../network/cipAPI";
import AgTable from "../../components/AgTable";
import Charts from "../../FileUpload/chart";
import {
  pressureFormatter,
  dateFormatter,
  typeFormatter,
  getSortedData,
} from "../../utils/tableDataFormatter";
import PageLoading from "../../components/PageLoading";
import { useDispatch, useSelector } from "react-redux";
import {
  storeClenaingEffectiness,
  storeClenaingEffectinessThreshold,
} from "../../Store/TemplateStore/template.action";
//import CAStore from "../../Store/TemplateStore/template.store";
import createNotification, {
  ERROR_NOTIFICATION,
} from "../../components/Notifications";
import { XlsNormalizefileKey } from "../../utils/constantsString";
import { useTranslation } from "react-i18next";
import { extractPlantId, getIndex } from "../../utils/Utils";
import AdvanceSettings from "../analyseData/advancedSettings";
import DupontButton from "../../components/DupontButton";
import "./index.scss";

const HistoricalCIPEffectivness = ({ activeStep }) => {
  const { t } = useTranslation();
  const [rowData, setRowData] = useState(
    useSelector((state) => state.cleaningEffectiness)
  );
  const [foulingType, setfoulingType] = useState(
    useSelector((state) => state.foulingType)
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isSettingsDialogOpen, setIsSettingsDialogOpen] = useState(false);
  const [processedPercentage, setprocessedPercentage] = useState(false);
  const plantId = extractPlantId();

  const cleaningResponse = useSelector((state) => state.cleanData);
  const selectedTrain = useSelector((state) => state.selTrain);
  const date = useSelector((state) => state.cleanDate);
  const cips = useSelector((state) => state.cips);
  const [threshold, setThreshold] = useState(null);
  const dispatch = useDispatch();
  const intervalIdRef = React.useRef(null);

  const currentYear = useMemo(() => new Date().getFullYear(), []);

  const handleSettingsDialog = (open) => {
    setIsSettingsDialogOpen(open);
  };
  const reasonFormatter = (params) => {
    const { data } = params;
    const reason = data?.reason;
    if (
      !reason ||
      (Array.isArray(reason) && reason.length === 0) ||
      (typeof reason === "string" && !reason.trim())
    ) {
      return t("foulingStrings.noReason");
    }

    const typeArr = Array.isArray(reason)
      ? reason
          .filter(Boolean)
          .map((item) => String(item).trim())
          .filter(Boolean)
      : reason
          .split(",")
          .map((item) => item.trim())
          .filter(Boolean);

    if (!typeArr.length) {
      return t("foulingStrings.noReason");
    }

    return typeArr.map((item) => foulingType?.[item] || item).join(", ");
  };

  const colDefs = [
    {
      headerName: "",
      children: [
        {
          headerName: t("HistoricalCIPEffectivnessTableStrings.index"),
          valueGetter: (params) => getIndex(params, params.data.start_date),
          flex: 0.75,
        },
        {
          headerName: t("HistoricalCIPEffectivnessTableStrings.type"),
          field: "type",
          sortable: true,
          flex: 1,
          valueFormatter: (params) => typeFormatter(params, t),
        },
        {
          headerName: t("HistoricalCIPEffectivnessTableStrings.start_date"),
          field: "start_date",
          sortable: true,
          flex: 1,
          valueFormatter: dateFormatter,
        },
        {
          headerName: t("HistoricalCIPEffectivnessTableStrings.reason"),
          field: "reason",
          sortable: true,
          flex: 1.5,
          valueFormatter: reasonFormatter,
          valueGetter: reasonFormatter,
        },
      ],
    },
    {
      headerName: t("cleaningEffectivnessStrings.cleaningEffectiveness"),
      headerClass: "my-css-class",
      children: [
        {
          headerName: t("HistoricalCIPEffectivnessTableStrings.pressure_drop"),
          field: "pressure_drop",
          sortable: true,
          flex: 1,
          valueFormatter: pressureFormatter,
          useValueFormatterForExport: true,
        },
        {
          headerName: t("HistoricalCIPEffectivnessTableStrings.flow"),
          field: "flow",
          sortable: true,
          flex: 1,
          valueFormatter: pressureFormatter,
          useValueFormatterForExport: true,
        },
        {
          headerName: t("HistoricalCIPEffectivnessTableStrings.salt_passage"),
          field: "salt_passage",
          sortable: true,
          flex: 1,
          valueFormatter: pressureFormatter,
        },
      ],
    },
  ];

  const completed_state = (responseData) => {
    const data = JSON.parse(responseData.result);
    const result = Object.keys(data?.cip).map((key, index) => ({
      start_date: data.cip[index]["sd"],
      type: data.cip[index]["type"],
      pressure_drop:
        data.norm_pressure_drop_flag[index] === 1
          ? `${data[XlsNormalizefileKey.normalizeDPRack2][index]}ᵇ`
          : data[XlsNormalizefileKey.normalizeDPRack2][index],
      flow:
        data.norm_permeate_flow_flag[index] === 1
          ? `${data[XlsNormalizefileKey.normalizePermeateFlow][index]}ᵃ`
          : data[XlsNormalizefileKey.normalizePermeateFlow][index],
      salt_passage:
        data[XlsNormalizefileKey.normalizeSaltPassage] &&
        data[XlsNormalizefileKey.normalizeSaltPassage][index]
          ? data[XlsNormalizefileKey.normalizeSaltPassage][index]
          : "-",
      reason: data.cip_reason[index]?.join(",  "),
    }));
    const sortedData = getSortedData(result);
    dispatch(storeClenaingEffectiness(sortedData));
    setRowData(sortedData);
    // fetch threshold data from result
    if (data?.threshold) {
      setThreshold(data?.threshold);
      dispatch(storeClenaingEffectinessThreshold(data?.threshold));
    }
    setIsLoading(false);
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = null;
    }
  };
  const fetchCleaningEffectivenessData = async () => {
    try {
      const res = await cleaningEffectivness(selectedTrain);
      if (res && res.data?.status === "completed") {
        completed_state(res?.data);
      } else {
        if (intervalIdRef.current) {
          clearInterval(intervalIdRef.current);
        }
        intervalIdRef.current = setInterval(function () {
          checkStatus(res.data?.task_id);
        }, 5000);
        setprocessedPercentage("1%");
        setIsLoading(true);
      }
    } catch (err) {
      setRowData([]);
      setIsLoading(false);
      createNotification(
        ERROR_NOTIFICATION,
        t("notificationStrings.fetchFail"),
        ""
      );
    }
  };

  useEffect(() => {
    if (plantId) {
      fetchCleaningEffectivenessData();
    }

    // Cleanup function to clear interval when component unmounts
    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
    };
  }, []);

  const checkStatus = async (task_id) => {
    try {
      const effectivenessStatus = await cleaningEffectivnessStatus(
        task_id,
        selectedTrain
      );
      try {
        if (effectivenessStatus?.data?.status === "completed") {
          completed_state(effectivenessStatus?.data);
        } else if (effectivenessStatus?.data?.status === "pending") {
          setIsLoading(false);
          if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
          }
          setprocessedPercentage("");
        } else if (effectivenessStatus?.data?.status === "running") {
          setIsLoading(true);
          setprocessedPercentage(effectivenessStatus?.data.processed);
        } else if (effectivenessStatus?.data?.status === "failed") {
          setIsLoading(false);
          // setprocessedPercentage("");
          if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
          }
          createNotification(
            ERROR_NOTIFICATION,
            t("notificationStrings.fetchFail"),
            ""
          );
        }
      } catch (error) {
        if (intervalIdRef.current) {
          clearInterval(intervalIdRef.current);
          intervalIdRef.current = null;
        }
        setRowData([]);
        setIsLoading(false);
        createNotification(
          ERROR_NOTIFICATION,
          t("notificationStrings.fetchFail"),
          ""
        );
      }
    } catch (err) {
      if (err.code === "ERR_NETWORK" || err.response.status === 502) {
        console.log("Error is " + err);
      } else {
        if (intervalIdRef.current) {
          clearInterval(intervalIdRef.current);
          intervalIdRef.current = null;
        }
        setRowData([]);
        setIsLoading(false);
        createNotification(
          ERROR_NOTIFICATION,
          t("notificationStrings.fetchFail"),
          ""
        );
      }
    }
  };
  const hasInvalidData = rowData?.some(
    (data) =>
      data.flow === null ||
      isNaN(data.flow) ||
      data.pressure_drop === null ||
      isNaN(data.pressure_drop) ||
      data.salt_passage === null ||
      isNaN(data.salt_passage)
  );

  const hasValuesGreaterThan100 = rowData?.some(
    (data) =>
      data.flow > 100 || data.pressure_drop > 100 || data.salt_passage > 100
  );

  const hasValuesLessThan0 = rowData?.some(
    (data) => data.flow < 0 || data.pressure_drop < 0 || data.salt_passage < 0
  );

  const hasSuperscript = (rowData, superscript) => {
    return rowData?.some(
      (data) =>
        (typeof data.flow === "string" && data.flow.includes(superscript)) ||
        (typeof data.pressure_drop === "string" &&
          data.pressure_drop.includes(superscript))
    );
  };
  const hasSuperscriptb = hasSuperscript(rowData, "ᵇ");
  const hasSuperscripta = hasSuperscript(rowData, "ᵃ");

  return (
    <div>
      <div className="descriptionText marginTop10 marginBtm10">
        {t("cleaningEffectivnessStrings.cleaningDescription")}
      </div>

      {isLoading || !rowData ? (
        <PageLoading
          customHeight={"100px"}
          iconHeight={"height--100"}
          message={t("ValueStrings.loaderMessage")}
          percentage={processedPercentage}
        ></PageLoading>
      ) : (
        <>
          <div className="chart">
            <Charts
              plantId={plantId}
              cleaningResponse={cleaningResponse}
              date={date}
              cips={cips}
              threshold={threshold}
              activeStep={activeStep}
            />
          </div>

          <AgTable
            columnDefs={colDefs}
            rowData={rowData}
            name={`${t("excelSheetNames.cleaningEffectivness")}.csv`}
            dynamicTextConditions={{
              hasInvalidData,
              hasValuesGreaterThan100,
              hasValuesLessThan0,
              rowData,
              hasSuperscripta,
              hasSuperscriptb,
            }}
          />
          <div>
            {rowData && (
              <div className="descriptionText marginTop10 marginBtm10">
                {t("cleaningEffectivnessStrings.note")}
              </div>
            )}
            {hasValuesGreaterThan100 && (
              <div className="descriptionText marginTop10 marginBtm10">
                {t("cleaningEffectivnessStrings.noteForValuesrGeaterThan100")}
              </div>
            )}
            {hasValuesLessThan0 && (
              <div className="descriptionText marginTop10 marginBtm10">
                {t("cleaningEffectivnessStrings.noteForValuesLessThan0")}
              </div>
            )}
            {hasInvalidData && (
              <div className="descriptionText marginTop10 marginBtm10">
                {t("cleaningEffectivnessStrings.noteWith*")}
              </div>
            )}
            {hasSuperscripta && (
              <div className="descriptionText marginTop10 marginBtm10">
                {t("cleaningEffectivnessStrings.notewithsuperscripta")}
              </div>
            )}
            {hasSuperscriptb && (
              <div className="descriptionText marginTop10 marginBtm10">
                {t("cleaningEffectivnessStrings.notewithsuperscriptb")}
              </div>
            )}
          </div>
          <hr />
          <div className="RO-disclaimer">
            {t("disclaimer", { currentYear })}
          </div>
        </>
      )}
      <DupontButton
        customClass="fixed-settings-btn"
        onClick={() => handleSettingsDialog(true)}
        disabled={isLoading}
      >
        {t("analyseData.settings")}
      </DupontButton>
      {isSettingsDialogOpen && (
        <AdvanceSettings
          isSettingsDialogOpen={isSettingsDialogOpen}
          handleSettingsDialogClose={() => handleSettingsDialog(false)}
          selectedTrain={selectedTrain}
          cleaningEffectivenessCalculation
          onSave={fetchCleaningEffectivenessData}
        />
      )}
    </div>
  );
};

export default HistoricalCIPEffectivness;
